<template>
  <vx-card no-shadow v-if="showWindow">
    <vs-button @click="addCompany()" color="success" type="border">Add company</vs-button>
    <vs-popup classContent="popup-example" title="Add company" :active.sync="popupCompanies">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Company name" v-model="params.company_name1" :disabled="params.type==='edit-company'"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Company Address" v-model="params.address1"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Industry
          <v-select :closeOnSelect="true" v-model="params.industry_name" label="industry_name" :options="$store.state.pickLists.indestries" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Registration number" v-model="params.registration_number1"/>
        </div>
      </div>
      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select Country"
              autocomplete
              class="selectExample inputx w-full"
              label="Country"
              v-model="params.country"
              >
              <vs-select-item :key="index" :value="item.cl_Country" :text="item.cl_Country" v-for="(item,index) in country" />
          </vs-select>
        </div>
      </div>       
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Incorporation date
          <flat-pickr class="w-full" :config="configFromdateTimePicker" v-model="params.incorporation_date1" placeholder="Select date" @on-change="onFromChange" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Comments" v-model="params.comments1" />
        </div>
      </div>
      <div class="vx-row mb-6" v-if="params.type==='edit-company'">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select Status"
              autocomplete
              class="selectExample inputx w-full"
              label="Status"
              v-model="params.status"
              >
              <vs-select-item :key="index" :value="item.st_name" :text="item.st_name" v-for="(item,index) in bizStatus" />
          </vs-select>
        </div>
      </div>   
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData()" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>    
    <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th v-for="(key,index) in tableColumns" :key="index">{{key}}</vs-th>
                <vs-th >Edit</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr v-for="(tr, indextr) in data" :key="indextr">
                   <vs-td v-for="(item,index) in data[indextr]" :data="item" :key="index">
                        {{item}}
                    </vs-td>
                    <vs-td :data="data[indextr].action">
                        <vs-button @click="editCompany(data[indextr])" color="success" type="border">Edit</vs-button>       
                    </vs-td>              
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import country from '../../../resources/country.json';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import bizStatus from '../../../resources/biz_get_statuses.json';
export default {
  data() {
    return {
      details:{},
      popupSend: false,
      popupCompanies: false,
      params: {type: 'add-company',country:null,incorporation_date1:'1970-01-01'},
      country:country,
      originalParams:{},
      bizStatus:bizStatus,
      tableData:[],
      tableColumns: [],
      popupUpdateBank:false,
      configFromdateTimePicker: {
        minDate: null,
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null
      },
    }
  },
  components:{
    'v-select': vSelect,
    flatPickr,
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/clients/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr);
    },
    showDoc: function(link){
      window.open(link, '_blank');
    },
    showUpdateBank(data){
      this.params = {};
      this.popupUpdateBank = true;
      this.params.bank_unique = data.account_number;
    },
    addCompany: function(){
      this.params= {type: 'add-company',country:null,incorporation_date1:'1970-01-01'};
      this.popupCompanies = true;
    },
    editCompany(data){
      this.reset();
      this.$set(this.params,'company_name1',data.company_name);
      this.$set(this.params,'address1',data.address);
      this.$set(this.params,'country',data.country);
      this.$set(this.params,'incorporation_date1',data.incorporation_date);
      this.$set(this.params,'registration_number1',data.registration_number);
      this.$set(this.params,'comments1',data.comments);
      this.$set(this.params,'type','edit-company');
      for(let i in this.params){
        this.$set(this.originalParams,i,this.params[i]);
      }
      this.popupCompanies = true;
    },
    sendData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', this.params.type);
      params.append('email', this.$route.params.email);
      if(params.type==='edit-company'){
        for(let i in this.params){
          if(this.originalParams[i]!==undefined && this.params[i]===this.originalParams[i]){
            params.append(i, '');
          } else{
            params.append(i, this.params[i]);
          }
        }
      } else{
        for(let i in this.params){
          params.append(i, this.params[i]);
        }
      }
      this.$vs.loading();
      axios.post("/api/client",params)
      .then((data) => {
        that.setData(true);
        that.$vs.loading.close();
        if(data.data[0].out1==='done!'/*|| that.successStatuses.indexOf(data.data[0].out1)!==-1*/){
          that.openAlert('success','Success',data.data[0].out1);
          that.reset();
        } else{
          that.openAlert('danger','Failed',data.data[0].out1);
        }
      })
      .catch((data) => { that.$vs.loading.close(); that.openAlert('danger','Failed',data.data[0].out1); })
    },
    reset: function(){
      this.popupCompanies= false;
      this.originalParams = {};
      this.params= {type: 'add-company',country:null,incorporation_date1:'1970-01-01'};
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-companies');
      params.append('email', this.$route.params.email);
      axios.post("/api/client",params)
      .then((response) => {
        that.tableData.splice(0);
        that.tableColumns.splice(0);        
        let header = JSON.parse(response.data[0].object);
        for(let i in header){
          that.tableColumns.push(i);
        }
        for(let i in response.data){
          let data = JSON.parse(response.data[i].object);
          that.tableData.push(data);
        }
      })
      .catch(() => { })
    },
  }
}
</script>
